import { useTranslation } from 'react-i18next';

import type { ReachReason } from '../sampleData';

/**
 * Why one person can log time, in words — "Allocated to 2 tasks", "In
 * Engineering". The people modal's Why column and the panel's Who this means
 * list read the same one, so the two never describe a person differently.
 */
export const useReasonLabel = () => {
  const { t } = useTranslation('pmDetails');
  return (reason: ReachReason): string => {
    switch (reason.kind) {
      case 'allocated':
        return t('reach.why.allocated', { count: reason.taskCount });
      case 'department':
        return t('reach.why.department', { name: reason.departmentName });
      case 'legalEntity':
        return t('reach.why.legalEntity', { name: reason.legalEntityName });
      default:
        return t(`reach.why.${reason.kind}`);
    }
  };
};
